<template>
  <div class="home-head">
    <img src="../../../assets/imgs/image.png" />
  </div>
</template>
  
  <script>
export default {
  name: "HomeHeaderView",
};
</script>
<style scoped>
.home-head {
  height: 60px;
  width:100%;
  text-align:'center';
  background-color: #015198;
}
.home-head img {
    width:60px;
    height:60px;
    border-radius:8px;
    margin-left: 5px;
}
</style>
